import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Intent } from "@blueprintjs/core";
import SendEmailPanel from "components/Common/SendEmailPanel";
import Toast from 'helpers/toaster';

// Email an estimate to the client, in a side panel (components/Common/SendEmailPanel).
@inject("quoteStore", "paymentStore", "invoiceStore")
@observer
class SendQuoteModal extends Component {

  componentDidMount() {
    let { object } = this.props.quoteStore.sendQuote;
    object.emailSubject = "Estimate [#"+this.props.quoteStore.quote.object.attributes.number+"] from "+this.props.quoteStore.quote.object.attributes.tenant.name
  }

  handleCloseQuoteInvoiceDialog() {
    this.props.onClose();
  }

  SendQuoteToEmail() {
    this.props.quoteStore.sendQuote.isLoading = true;
    this.props.quoteStore.SendQuoteToEmail()
      .then(() => {
        this.props.onClose();
        Toast.show({ message: "Estimate sent.", intent: Intent.SUCCESS });
      })
      .catch(() => {
        Toast.show({ message: "Couldn’t send the estimate. Try again.", intent: Intent.DANGER });
      })
      .finally(() => {
        this.props.quoteStore.sendQuote.isLoading = false;
      })
  }

  onEmailChange = (emails) => {
    this.props.quoteStore.sendQuote.object.emailTo = emails.map((contact) => contact.email);
  }

  render() {
    const { sendQuote, quote } = this.props.quoteStore;
    const client = quote.object.attributes && quote.object.attributes.client;
    return (
      <SendEmailPanel
        isOpen={this.props.isOpen}
        onClose={this.handleCloseQuoteInvoiceDialog.bind(this)}
        what="estimate"
        tone="estimates"
        object={sendQuote.object}
        contacts={client ? [{ email: client.email, name: client.name }] : []}
        busy={Boolean(sendQuote.isLoading)}
        onEmailChange={this.onEmailChange}
        onSend={this.SendQuoteToEmail.bind(this)}
      />
    )
  }

}

export default SendQuoteModal;
